import AutoRenewal from "./AutoRenewal";

export default AutoRenewal;